import styled from 'styled-components';

export const Card = styled.div`
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  margin-bottom: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
`;

export const CardBody = styled.div`
  flex: 1 1 auto;
  padding: 1.25rem;
`;

export const LoginBoxMsg = styled.p`
  text-align: center;
  font-size: 1rem;
  color: #666;
`;

export const InputGroup = styled.div`
  padding: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;

export const FormGroup = styled.div`
  padding: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;

export const Button = styled.button`
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  text-align: center;
  vertical-align: block;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
    border-color: #004085;
  }
`;


export const StyledSelect = styled.select`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

export const StyledInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;

export const FormImage = styled.div`
  flex: 1;
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-image: url('/dist/img/ArbolPaz_1280x960.jpg');
  left: 0;
  top: 0;
  z-index: 1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const LoginBox = styled.div`
    top: 20%;
    left: 15%;
`;

export const LoginLogo = styled.div`
  font-size: 2.1rem;
  font-weight: 300;
  margin-bottom: .9rem;
  text-align: center;
`;

export const LockscreenFooter = styled.div`
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  text-align: center;
`;

export const ButtonLink = styled.button`
    color: black;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
`;

export const FormControlButton = styled.button`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
`;


export const CardBodyTableResponsive = styled.div`
  padding: 0;
  overflow-x: auto;
`;

export const ContentWrapper = styled.div`
  min-height: calc(100vh - calc(3.5rem + 1px) - calc(3.5rem + 1px));
`;

export const ContentHeader = styled.section`
  padding: 15px 0.5rem;
  
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const EditButton = styled.button`
  background-color: skyblue;
  padding: 12px 20px;
  font-size: 1.5rem;
  border-radius: 8px;
  border: none;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;

`;